const RaindropTextFootnote = ({ children, className = "" }) => {
  return (
    <div
      className={`w-full max-w-xs text-xs text-center font-semibold text-color-text-secondary dark:text-color-dark-text-secondary ${className}`}
    >
      {children}
    </div>
  );
};

export default RaindropTextFootnote;
